import {log} from "@dp-instant/utils";
import {Action, di} from "@dp-instant/core";
import {inject, injectable} from "inversify";
import {TypesGame} from "@game/TypesGame";
import {GameModel} from "@game/coregame/model/GameModel";
import {UIEvents} from "@dp-instant/ui";
import {PopupType} from "@game/ui/PopupType";
import {TypesSocial} from "@dp-instant/interfaces";
import {ISocial} from "@dp-instant/social";
import {GenerateShareImageAction} from "@game/actions/GenerateShareImageAction";

@injectable()
export class LevelCompletedPopupAction extends Action {
    @inject(TypesGame.model)
    private readonly model: GameModel;

    @inject(TypesSocial.model)
    private readonly social: ISocial;

    async execute(): Promise<any> {
        const levelName = this.model.currentContinent.data.id;
        const points = +this.social.me.scoreSession.toFixed();

        //In case of yandex it needs to reset shareImage
        const shareImage = ["ya", "vk", "gd"].includes(this.social.socialPlatform)
            ? undefined
            : await this.generateImage(levelName, points);

        const shared = await new Promise<boolean>(onContinue => {
            this.dispatch(UIEvents.POPUP, {
                id: PopupType.LEVEL_COMPLETED,
                props: {
                    levelName,
                    points,
                    shareImage,
                    onContinue
                }
            });
        });
        log.debug("LevelCompletedPopupAction shared", shared);
    }
    protected async generateImage(levelName: string, points: number): Promise<string | undefined> {
        try {
            let result = await di
                .get<GenerateShareImageAction>(GenerateShareImageAction)
                .run({points});
            const {image} = result;
            return image;
        } catch (e) {
            log.warn("Image generation failed", e);
        }
    }
}
